"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var widgets_1 = require("@tableau/widgets");
var DataGrid_1 = require("./DataGrid");
var DataGridColors_1 = require("./DataGridColors");
var DefaultFormatter_1 = require("./DefaultFormatter");
var Utils_1 = require("./Utils");
var BodyCell = /** @class */ (function (_super) {
    tslib_1.__extends(BodyCell, _super);
    function BodyCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cellRef = null;
        _this.updateCellRef = function (ref) {
            _this.cellRef = ref;
        };
        _this.handleClick = function (e) {
            if (_this.props.onCellClick) {
                var cell = _this.getCell();
                _this.props.onCellClick(_this.props.row.data, cell, e);
            }
        };
        _this.handleDoubleClick = function (e) {
            if (_this.props.onCellDoubleClick) {
                var cell = _this.getCell();
                _this.props.onCellDoubleClick(_this.props.row.data, cell, e);
            }
        };
        _this.handleContextMenu = function (e) {
            if (_this.props.onCellContextMenu) {
                var cell = _this.getCell();
                _this.props.onCellContextMenu(_this.props.row.data, cell, e);
            }
        };
        _this.handleFocus = function (e) {
            if (_this.cellRef && _this.cellRef.contains(e.target)) {
                _this.props.onCellFocus(DataGrid_1.DataGrid.FocusLocation.Body, _this.props.colIdx, _this.props.rowIdx);
            }
        };
        return _this;
    }
    BodyCell.prototype.componentDidMount = function () {
        if (this.props.reportWidthFn) {
            this.props.reportWidthFn(this.props.col.name, Utils_1.measureWidth(this));
        }
        this.syncFocus();
    };
    BodyCell.prototype.componentDidUpdate = function () {
        this.syncFocus();
    };
    BodyCell.prototype.shouldTakeFocus = function () {
        if (!this.props.isFocused || !this.cellRef) {
            return false;
        }
        var cellContainsFocus = this.cellRef && this.cellRef.contains(document.activeElement);
        // TFSID 767568: IE11 allows non-focusable elements to get focus 🙄
        var ieInnerFocused = /Trident/.test(navigator.userAgent) && !Utils_1.isFocusable(document.activeElement);
        return !cellContainsFocus || ieInnerFocused;
    };
    BodyCell.prototype.syncFocus = function () {
        if (this.cellRef && this.shouldTakeFocus()) {
            this.cellRef.focus();
        }
    };
    BodyCell.prototype.getCell = function () {
        return { colIdx: this.props.colIdx, rowIdx: this.props.rowIdx, colKey: this.props.col.dataKey, rowKey: this.props.row.key };
    };
    BodyCell.prototype.render = function () {
        var pointerEventWrapperProps = {
            pointerClick: this.handleClick,
            pointerDoubleClick: this.handleDoubleClick,
        };
        var content = this.props.col.cellFormatter
            ? this.props.col.cellFormatter(this.props)
            : React.createElement(DefaultFormatter_1.DefaultFormatter, { value: this.props.value, testId: widgets_1.testId(this.props.rowIdx + '-' + this.props.colIdx, 'Cell') });
        var attrs = {
            'aria-colindex': this.props.colIdx + 1,
            'aria-rowindex': this.props.rowIdx + (this.context.showHeaders ? 2 : 1),
            'aria-selected': this.props.isSelected,
            className: 'tb-react-dg-bcell',
            'data-tb-test-id': this.props.col.name + BodyCell.CellTestIdSuffix,
            onContextMenu: this.handleContextMenu,
            onFocus: this.handleFocus,
            ref: this.updateCellRef,
            style: BodyCell.getStyle(this.props.isSelected, this.props.height, this.props.width, this.props.showVerticalGridLines),
            tabIndex: this.props.isTabbable ? 0 : -1,
            role: 'gridcell',
        };
        return (React.createElement(widgets_1.PointerEventWrapper, tslib_1.__assign({}, pointerEventWrapperProps),
            React.createElement("div", tslib_1.__assign({}, attrs), content)));
    };
    BodyCell.displayName = 'DataGridBodyCell';
    BodyCell.element = React.createFactory(BodyCell);
    BodyCell.contextTypes = {
        showHeaders: PropTypes.bool
    };
    return BodyCell;
}(React.PureComponent));
exports.BodyCell = BodyCell;
(function (BodyCell) {
    function getStyle(isSelected, height, width, showVerticalGridLines) {
        var borderBottomColor = isSelected ? DataGridColors_1.DataGridColors.SelectedGridLine : 'transparent';
        var borderRightColor = showVerticalGridLines ? (isSelected ? DataGridColors_1.DataGridColors.SelectedGridLine : DataGridColors_1.DataGridColors.VerticalGridLine) : 'transparent';
        return {
            backgroundColor: isSelected ? DataGridColors_1.DataGridColors.Selected : undefined,
            borderBottom: "1px solid " + borderBottomColor,
            borderRight: "1px solid " + borderRightColor,
            boxSizing: 'border-box',
            display: 'inline-block',
            height: height,
            lineHeight: height + 'px',
            verticalAlign: 'top',
            width: width
        };
    }
    BodyCell.getStyle = getStyle;
    ;
    BodyCell.CellTestIdSuffix = '-cell';
})(BodyCell = exports.BodyCell || (exports.BodyCell = {}));
exports.BodyCell = BodyCell;
//# sourceMappingURL=BodyCell.js.map